
import { Facilitator } from "./facilitator";

import { OlympiadExam } from "../schoolPrograms/olympiadExam/OlympiadExam";

export const FacilitatorOlympiadExamComponent = () => {

    return (<>
        <Facilitator>
            <OlympiadExam isAddFilesVisible={true} isDeleteFilesVisible={true} />

        </Facilitator>

    </>);
}